import { database } from "../index";
import { ATTENDANCE_SCHEMA, BUSINESS_SCHEMA, STAFF_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";

const attendanceModel = database.collections.get(ATTENDANCE_SCHEMA);

const staff_table = database.collections.get(STAFF_SCHEMA);

export const getStaffById = async (id) => await staff_table.find(id);

export const observeActiveStaff = (id) =>
  staff_table
    .query(
      Q.where("business_id", id),
      Q.on(BUSINESS_SCHEMA, Q.where("is_active", true))
    )
    .observeWithColumns([
      "name",
      "phone_number",
      "last_updated_at",
      "workdays",
      "joined_at",
      "salary",
      "salary_type",
      "working_hours",
      "job_title",
      "created_at",
    ]);

export const getAttendanceCount = async () =>
  await attendanceModel.query().fetchCount();

export const getStaffByBusiness = async (id) =>
  await staff_table.query(Q.on(BUSINESS_SCHEMA, "id", id)).fetch();

const prepareInsertion = (staff, attendances) => {
  return attendances.map((attendance) => {
    try {
      return attendanceModel.prepareCreate((field) => {
        field._raw.id = attendance.id;
        field.staff.set(staff);
        field.business.set(staff.business);
        field.attendance_at = attendance.attendance_at;
        field.check_in_at = attendance.check_in_at;
        field.check_out_at = attendance.check_out_at;
        field.payment = attendance.payment;
        field.last_updated_at = attendance.last_updated_at;
        field.status = attendance.status;
      });
    } catch (e) {
    }
  });
};

export const bulkCreateAttendance = async (staff, attendances) => {
  await database.write(async () => {
    const allRecords = prepareInsertion(staff, attendances);
    await database.batch(...allRecords);
  });
};

export const bulkDeleteStaffByBusiness = async (business_id) => {
  await database.write(async () => {
    let staff = await getStaffByBusiness(business_id);
    const allRecords = await prepareDeletion(staff);
    await database.batch(...allRecords);
  });
};

const prepareDeletion = async (allStaff) => {
  return await Promise.all(
    allStaff.map(async (staff) => {
      try {
        return staff.prepareMarkAsDeleted();
      } catch (err) {
      }
    })
  );
};
